export enum EvaluationRecordOutcomeStatus {
  Successful = "successful",
  Error = "error",
  Idle = "idle",
  Info = "info",
  Warning = "warning",
  Approve = "approve",
  Allow = "allow",
  Track = "track",
  Webhook = "webhook",
  PullRequest = "pull-request",
  Deny = "deny",
  Inbox = "inbox",
  Reject = "reject",
  Admin = "admin",
  Slack = "slack",
  Warn = "warn",
  Multiple = "multiple",
  Propose = "propose",
  Read = "read",
  Trigger = "trigger",
  Write = "write",
  Ignore = "ignore",
  None = "none",
  Undecided = "undecided",
}
